<mat-card class="product-card">
    <mat-card-content>
        <div class="table-scroll">
            <table class="product-table">
                <thead>
                    <tr>
                        <th class="col-name">
                            <div class="th-content">
                                <span class="th-title">{{ headerTitle }}</span>
                                <mat-icon class="info-icon" [matTooltip]="info" >
                                    info
                                </mat-icon>
                                <span class="list_count" *ngIf="productList.length > 0">(Count-{{ productList.length }})</span> 
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let product of productList">
                        <!-- Parent row -->
                        <tr class="row-main" (click)="move(product.productId)">
                            <td class="col-name">
                                <mat-icon class="expand-icon" 
                                    [ngStyle]="{ visibility: product.type === 'Product Group' ? 'visible' : 'hidden' }"
                                    (click)="toggleExpand(product, $event)">
                                    {{ product.isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                                </mat-icon>

                                <span class="cell-text">{{ product.name }}</span>

                                <mat-icon class="row-arrow"   [matTooltip]="isCurated? 'Remove from Curated list': 'Add to Curated list'" matTooltipPosition="above">
                                    {{ isCurated ? 'keyboard_backspace' : 'arrow_right_alt' }}
                                      <!-- {{ isCurated ? 'remove_circle_outline' : 'arrow_right_alt' }}  -->
                                </mat-icon>
                            </td>
                        </tr>

                        <!-- Child rows -->
                        <tr *ngFor="let variant of product.variants" class="row-child" [hidden]="!product.isExpanded">
                            <td class="col-name child-cell" (click)="move(product.productId, variant.variantId)">
                                <mat-icon class="expand-icon"  style="visibility: hidden;">keyboard_arrow_down</mat-icon>
                                <mat-icon class="expand-icon"  style="visibility: hidden;">keyboard_arrow_down</mat-icon>
                                <span class="cell-text">{{ variant.name }}</span>
                                <mat-icon class="row-arrow"  [matTooltip]="isCurated? 'Remove from Curated list': 'Add to Curated list'" matTooltipPosition="above">
                                    <!-- {{ isCurated ? 'delete_outline' : 'arrow_right_alt' }} -->
                                      <!-- {{ isCurated ? 'remove_circle_outline' : 'arrow_right_alt' }}  -->
                                      {{ isCurated ? 'keyboard_backspace' : 'arrow_right_alt' }}
                                </mat-icon>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>

            </table>
        </div>
    </mat-card-content>
</mat-card>